// extracted by mini-css-extract-plugin
export var active = "_63-a";
export var activeIndicator = "_63-9";
export var disabled = "_63-b";
export var fullWidth = "_63-2";
export var lg = "_63-7";
export var md = "_63-6";
export var redoButtonTabGroup = "_63-0";
export var sm = "_63-5";
export var tabButton = "_63-4";
export var tabButtonsContainer = "_63-1";
export var themeDestructive = "_63-d";
export var themeNormal = "_63-c";
export var themeSuccess = "_63-e";
export var xl = "_63-8";
export var xs = "_63-3";